import { OpenDuty } from '../types';

export const hasIcons = ({
  sentToFlex,
  isSentForSelfMatch,
  subscribedEmployees,
  preferredEmployees
}: OpenDuty) =>
  Boolean(
    sentToFlex ||
      isSentForSelfMatch ||
      subscribedEmployees?.length ||
      preferredEmployees?.length
  );
